const PageHero = ({ eyebrow, title, highlight, description, children }) => {
  return (
    <section className="relative overflow-hidden bg-fairway text-cream">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-25"
        style={{ backgroundImage: "url('/campo.png')" }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-fairway/75 via-fairway/85 to-fairway" aria-hidden="true" />
      <div className="relative mx-auto max-w-4xl px-4 py-20 text-center sm:px-6 md:py-28 lg:px-8">
        {eyebrow && (
          <p className="eyebrow mb-5 text-sun">{eyebrow}</p>
        )}
        <h1 className="font-serif text-4xl font-semibold leading-tight tracking-tight md:text-6xl">
          {title}
          {highlight && (
            <>
              {' '}
              <em className="not-italic text-sun">{highlight}</em>
            </>
          )}
        </h1>
        {description && (
          <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-cream/85 md:text-xl">
            {description}
          </p>
        )}
        {children}
      </div>
    </section>
  )
}

export default PageHero
